export default __webpack_public_path__ + "static/media/sematuana1.61cfc115.jpg";